// helpers/featureDefinitions/curtainFeatures.js
export const solidcurtainFeatures = [
    {
        slug: 'location',
        name: 'Location',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'LocationSelector',
            fields: [
                {
                    slug: 'country',
                    name: 'Country',
                    type: 'select',
                    options: [
                        { value: 'IN', label: 'India' },
                        { value: 'UK', label: 'United Kingdom' },
                        { value: 'UAE', label: 'UAE' },
                        { value: 'KSA', label: 'KSA' },
                        { value: 'US', label: 'United States' }
                    ],
                    required: true,
                    default: 'IN'
                }
            ]
        }
    },
    {
        slug: 'quantity',
        name: 'Quantity',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'PAIR', label: 'Pair', default: true },
            { value: 'SINGLE', label: 'Single', default: false }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Select Quantity'
        }
    },
    {
        slug: 'dimensions',
        name: 'Dimensions',
        type: 'dimension',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'DimensionInput',
            fields: ['width', 'height', 'unit'],
            defaultUnit: 'inches'
        },
        default: {
            width: 119,
            height: 119,
            unit: 'inches'
        },
    },
    {
        slug: 'orientation',
        name: 'Orientation',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'CENTRE_OPEN', label: 'Centre Open' },
            { value: 'LEFT_TO_RIGHT', label: 'Left to Right' },
            { value: 'RIGHT_TO_LEFT', label: 'Right to Left' }
        ],
        dependencies: [
            {
                featureSlug: 'quantity',
                condition: 'PAIR',
                allowedValues: ['CENTRE_OPEN']
            },
            {
                featureSlug: 'quantity',
                condition: 'SINGLE',
                allowedValues: ['LEFT_TO_RIGHT', 'RIGHT_TO_LEFT']
            }
        ],
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'pleat',
        name: 'Pleat Style',
        type: 'select',
        required: false,
        affectsPrice: true,
        options: [
            { value: 'PINCH', label: 'Pinch Pleat' },
            { value: 'APL', label: 'American Pleat' },
        ],
        dependencies: [],
        default: 'PINCH',
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Select Pleat'
        }
    },
    {
        slug: 'liningType',
        name: 'Lining Type',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: 'BLACKOUT', label: 'Blackout', priceImpact: 'fixed' },
            { value: 'DIMOUT', label: 'Dimout', priceImpact: 'fixed' },
            { value: 'STANDARD', label: 'Standard', priceImpact: 'fixed' },
            { value: 'NONE', label: 'None', priceImpact: 'fixed' }
        ],
        dependencies: [],
        default: 'NONE',
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'thermalInterlining',
        name: 'Thermal Interlining',
        type: 'select',
        required: false,
        affectsPrice: true,
        options: [
            { value: true, label: 'Yes', priceImpact: 'fixed' },
            { value: false, label: 'No', priceImpact: 'fixed' }
        ],
        dependencies: [],
        default: false,
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'mountType',
        name: 'Mount Type',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'WALL', label: 'Wall Mount' },
            { value: 'CEILING', label: 'Ceiling Mount' }
        ],
        dependencies: [],
        default: 'WALL',
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'hardware',
        name: 'Hardware',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'HardwareSelector',
            fields: [
                {
                    slug: 'hardwareType',
                    name: 'Hardware Type',
                    type: 'select',
                    options: [
                        { value: 'MOTORIZED', label: 'Motorized' },
                        { value: 'MANUAL', label: 'Manual' },
                        { value: 'NONE', label: 'No Hardware' }
                    ],
                    required: true,
                    default: 'NONE'
                },
                {
                    slug: 'motorizedType',
                    name: 'Motorized Option',
                    type: 'select',
                    options: [
                        { value: 'REMOTE', label: 'Remote' },
                        { value: 'HOME_AUTOMATION', label: 'Home Automation' }
                    ],
                    default: 'HOME_AUTOMATION',
                    required: false,
                    dependencies: [
                        {
                            field: 'hardwareType',
                            value: 'MOTORIZED'
                        }
                    ]
                },
                {
                    slug: 'vendor',
                    name: 'Vendor',
                    type: 'vendor-select',
                    required: true,
                    dependsOn: ['location.country']
                }
            ]
        }
    },
];

export const sheercurtainFeatures = [
    {
        slug: 'location',
        name: 'Location',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'LocationSelector',
            fields: [
                {
                    slug: 'country',
                    name: 'Country',
                    type: 'select',
                    options: [
                        { value: 'IN', label: 'India' },
                        { value: 'UK', label: 'United Kingdom' },
                        { value: 'UAE', label: 'UAE' },
                        { value: 'KSA', label: 'KSA' },
                        { value: 'US', label: 'United States' }
                    ],
                    required: true,
                    default: 'IN'
                }
            ]
        }
    },
    {
        slug: 'quantity',
        name: 'Quantity',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'PAIR', label: 'Pair', default: true },
            { value: 'SINGLE', label: 'Single', default: false }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Select Quantity'
        }
    },
    {
        slug: 'dimensions',
        name: 'Dimensions',
        type: 'dimension',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'DimensionInput',
            fields: ['width', 'height', 'unit'],
            defaultUnit: 'inches'
        },
        default: {
            width: 119,
            height: 119,
            unit: 'inches'
        },
    },
    {
        slug: 'orientation',
        name: 'Orientation',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'CENTRE_OPEN', label: 'Centre Open' },
            { value: 'LEFT_TO_RIGHT', label: 'Left to Right' },
            { value: 'RIGHT_TO_LEFT', label: 'Right to Left' }
        ],
        dependencies: [
            {
                featureSlug: 'quantity',
                condition: 'PAIR',
                allowedValues: ['CENTRE_OPEN']
            },
            {
                featureSlug: 'quantity',
                condition: 'SINGLE',
                allowedValues: ['LEFT_TO_RIGHT', 'RIGHT_TO_LEFT']
            }
        ],
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'pleat',
        name: 'Pleat Style',
        type: 'select',
        required: false,
        affectsPrice: true,
        options: [
            { value: 'RIPPLE', label: 'Ripple Pleat' },
            { value: 'APL', label: 'American Pleat' },
        ],
        dependencies: [],
        default: 'RIPPLE',
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Select Pleat'
        }
    },
    {
        slug: 'mountType',
        name: 'Mount Type',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'WALL', label: 'Wall Mount' },
            { value: 'CEILING', label: 'Ceiling Mount' }
        ],
        dependencies: [],
        default: 'WALL',
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'hardware',
        name: 'Hardware',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'HardwareSelector',
            fields: [
                {
                    slug: 'hardwareType',
                    name: 'Hardware Type',
                    type: 'select',
                    options: [
                        { value: 'MOTORIZED', label: 'Motorized' },
                        { value: 'MANUAL', label: 'Manual' },
                        { value: 'NONE', label: 'No Hardware' }
                    ],
                    required: true,
                    default: 'NONE'
                },
                {
                    slug: 'motorizedType',
                    name: 'Motorized Option',
                    type: 'select',
                    options: [
                        { value: 'REMOTE', label: 'Remote' },
                        { value: 'HOME_AUTOMATION', label: 'Home Automation' }
                    ],
                    default: 'HOME_AUTOMATION',
                    required: false,
                    dependencies: [
                        {
                            field: 'hardwareType',
                            value: 'MOTORIZED'
                        }
                    ]
                },
                {
                    slug: 'vendor',
                    name: 'Vendor',
                    type: 'vendor-select',
                    required: true,
                    dependsOn: ['location.country']
                }
            ]
        }
    },
];
export const romanBlindFeatures = [
    {
        slug: 'location',
        name: 'Location',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'LocationSelector',
            fields: [
                {
                    slug: 'country',
                    name: 'Country',
                    type: 'select',
                    options: [
                        { value: 'IN', label: 'India' },
                        { value: 'UK', label: 'United Kingdom' },
                        { value: 'UAE', label: 'UAE' },
                        { value: 'KSA', label: 'KSA' },
                        { value: 'US', label: 'United States' }
                    ],
                    required: true,
                    default: 'IN'
                }
            ]
        }
    },
    {
        slug: 'quantity',
        name: 'Quantity',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'PAIR', label: 'Pair', default: true },
            { value: 'SINGLE', label: 'Single', default: false }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Select Quantity'
        }
    },
    {
        slug: 'dimensions',
        name: 'Dimensions',
        type: 'dimension',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'DimensionInput',
            fields: ['width', 'height', 'unit'],
            defaultUnit: 'inches'
        },
        default: {
            width: 80,
            height: 80,
            unit: 'inches'
        },
    },
    {
        slug: 'liningType',
        name: 'Lining Type',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: 'BLACKOUT', label: 'Blackout', priceImpact: 'fixed' },
            { value: 'DIMOUT', label: 'Dimout', priceImpact: 'fixed' },
            { value: 'STANDARD', label: 'Standard', priceImpact: 'fixed' },
            { value: 'NONE', label: 'None', priceImpact: 'fixed' }
        ],
        dependencies: [],
        default: 'NONE',
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'fullness',
        name: 'Fullness',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: 1, label: '1', priceImpact: 'fixed' },
        ],
        dependencies: [],
        default: 1,
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'thermalInterlining',
        name: 'Thermal Interlining',
        type: 'select',
        required: false,
        affectsPrice: true,
        options: [
            { value: true, label: 'Yes', priceImpact: 'fixed' },
            { value: false, label: 'No', priceImpact: 'fixed' }
        ],
        dependencies: [],
        default: false,
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'mountType',
        name: 'Mount Type',
        type: 'select',
        required: true,
        affectsPrice: false,
        options: [
            { value: 'WALL', label: 'Wall Mount' },
            { value: 'CEILING', label: 'Ceiling Mount' }
        ],
        dependencies: [],
        default: 'WALL',
        uiConfig: {
            component: 'RadioGroup'
        }
    },
    {
        slug: 'hardware',
        name: 'Hardware',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'HardwareSelector',
            fields: [
                {
                    slug: 'hardwareType',
                    name: 'Hardware Type',
                    type: 'select',
                    options: [
                        { value: 'MOTORIZED', label: 'Motorized' },
                        { value: 'MANUAL', label: 'Manual' },
                        { value: 'NONE', label: 'No Hardware' }
                    ],
                    required: true,
                    default: 'NONE'
                },
                {
                    slug: 'motorizedType',
                    name: 'Motorized Option',
                    type: 'select',
                    options: [
                        { value: 'REMOTE', label: 'Remote' },
                        { value: 'HOME_AUTOMATION', label: 'Home Automation' }
                    ],
                    default: 'HOME_AUTOMATION',
                    required: false,
                    dependencies: [
                        {
                            field: 'hardwareType',
                            value: 'MOTORIZED'
                        }
                    ]
                },
                {
                    slug: 'vendor',
                    name: 'Vendor',
                    type: 'vendor-select',
                    required: true,
                    dependsOn: ['location.country']
                }
            ]
        }
    },
];

export const rollerBlindFeatures = [
    {
        slug: 'location',
        name: 'Location',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'LocationSelector',
            fields: [
                {
                    slug: 'country',
                    name: 'Country',
                    type: 'select',
                    options: [
                        { value: 'IN', label: 'India' },
                        { value: 'UK', label: 'United Kingdom' },
                        { value: 'UAE', label: 'UAE' },
                        { value: 'KSA', label: 'KSA' },
                        { value: 'US', label: 'United States' }
                    ],
                    required: true,
                    default: 'IN'
                }
            ]
        }
    },
    {
        slug: 'dimensions',
        name: 'Dimensions',
        type: 'dimension',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'DimensionInput',
            fields: ['width', 'height', 'unit'],
            defaultUnit: 'inches'
        },
        default: {
            width: 80,
            height: 80,
            unit: 'inches'
        },
    },
    {
        slug: 'module',
        name: 'Module',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: true, label: 'With Module', default: true },
            { value: false, label: 'Without Module', default: false }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Module'
        },
    },
    {
        slug: 'facia',
        name: 'Facia',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: true, label: 'With Facia', default: true },
            { value: false, label: 'Without Facia', default: false }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Facia'
        }
    },
    {
        slug: 'cassette',
        name: 'Cassete',
        type: 'select',
        required: true,
        affectsPrice: true,
        options: [
            { value: true, label: 'With Cassette', default: false },
            { value: false, label: 'Without Cassette', default: true }
        ],
        dependencies: [],
        uiConfig: {
            component: 'RadioGroup',
            groupLabel: 'Side Cassette'
        }
    },
    {
        slug: 'hardware',
        name: 'Hardware',
        type: 'nested',
        required: true,
        affectsPrice: true,
        options: [],
        dependencies: [],
        uiConfig: {
            component: 'HardwareSelector',
            fields: [
                {
                    slug: 'hardwareType',
                    name: 'Hardware Type',
                    type: 'select',
                    options: [
                        { value: 'MOTORIZED', label: 'Motorized' },
                        { value: 'MANUAL', label: 'Manual' },
                        { value: 'NONE', label: 'No Hardware' }
                    ],
                    required: true,
                    default: 'NONE'
                },
                {
                    slug: 'motorizedType',
                    name: 'Motorized Option',
                    type: 'select',
                    options: [
                        { value: 'REMOTE', label: 'Remote' },
                        { value: 'HOME_AUTOMATION', label: 'Home Automation' }
                    ],
                    default: 'HOME_AUTOMATION',
                    required: false,
                    dependencies: [
                        {
                            field: 'hardwareType',
                            value: 'MOTORIZED'
                        }
                    ]
                },
                {
                    slug: 'vendor',
                    name: 'Vendor',
                    type: 'vendor-select',
                    required: true,
                    dependsOn: ['location.country']
                }
            ]
        }
    },
];


// Helper to get features by product type
export const getFeaturesByProductType = (productType) => {
    const featuresMap = {
        SOLID_CURTAIN: solidcurtainFeatures,
        SHEER_CURTAIN: sheercurtainFeatures,
        ROMAN_BLIND: romanBlindFeatures, // Similar for now
        ROLLER_BLIND: rollerBlindFeatures
        // Add other product types as needed
    };
    return featuresMap[productType] || [];
};

export const getDefaultValuesFromFeatures = (features) => {
    const defaults = {};

    features.forEach(feature => {
        // Handle features with direct default property (including nested objects)
        if (feature.default !== undefined) {
            defaults[feature.slug] = feature.default;
        }
        // Handle nested features with fields
        else if (feature.type === 'nested' && feature.uiConfig?.fields) {
            const nestedDefaults = {};

            // Check if any fields have defaults
            feature.uiConfig.fields.forEach(field => {
                if (field.default !== undefined) {
                    nestedDefaults[field.slug] = field.default;
                }
                // Handle select fields with default option
                else if (field.type === 'select' && field.options) {
                    const defaultOption = field.options.find(opt => opt.default);
                    if (defaultOption) {
                        nestedDefaults[field.slug] = defaultOption.value;
                    }
                }
            });

            // Only add if there are nested defaults
            if (Object.keys(nestedDefaults).length > 0) {
                defaults[feature.slug] = nestedDefaults;
            }
        }
        // Handle regular features with default options
        else if (feature.options) {
            const defaultOption = feature.options.find(opt => opt.default);
            if (defaultOption) {
                defaults[feature.slug] = defaultOption.value;
            }
        }
    });

    return defaults;
};